const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Uploaded files must be served through /api so the production ingress routes them to the backend
export const fileUrl = (url) => {
  if (!url) return '';
  const idx = url.indexOf('/static/uploads/');
  if (idx !== -1) return `${BACKEND_URL}/api${url.slice(idx)}`;
  if (url.startsWith('http')) return url;
  return `${BACKEND_URL}${url}`;
};
